import secureLocalStorage from "react-secure-storage";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { getCurrentDate } from "../../../utils/getCurrentDate";
import { enterLogin } from "./enterLogin";
import { fingerPrint } from "../../../utils/fingerPrint";
import { getDeviceInfo } from "../../../utils/getDeviceInfo";

export const startLogin = async (params: stdObject) => {
  const {
    dispatch,
    loginData,
    quickLogin,
    cleanData,
    setMsg,
    setWindowValues,
    closeMsg,
    loginPack,
  } = params;
  setMsg("loading");

  const payloadLoginService = {
    ...loginData,
    date: getCurrentDate(true),
    fingerId: await fingerPrint(),
    ...getDeviceInfo(),
  };
  // console.log("payloadLoginService", payloadLoginService);

  const responseLoginService: stdObject = await sendData({
    endPoint: "login",
    payload: payloadLoginService,
    isToken: false,
  });
  // console.log("responseLoginService", responseLoginService);
  const {
    success,
    status,
    account,
    token,
    preToken,
    incorrect,
    ipBlocked,
    netWorkError,
  } = responseLoginService;

  if (success && status) {
    cleanData();
    if (token) {
      secureLocalStorage.setItem("token", token);
      enterLogin({ dispatch, callback: closeMsg, quickLogin, loginPack });
      return true;
    }
    if (preToken) {
      setMsg("resetPasswordModal");
      setWindowValues({ account, token: preToken, pass1: "", pass2: "" });
    }
  } else {
    let errorCode = "netWorkError";
    if (ipBlocked) {
      errorCode = "restrictedAccess";
    } else if (incorrect) {
      errorCode = "incorrectCredentials";
    } else if (netWorkError) {
      errorCode = "netWorkError";
    } else if (!status) {
      errorCode = "connectionError";
    } else {
      errorCode = "netWorkError";
    }
    return quickLogin ? errorCode : setMsg(errorCode);
  }
};
